import {useEffect, useRef} from 'react';
import Button from 'Components/FormComponents/Button';
import {ReactComponent as CloseIcon} from 'assets/icons/close.svg';

const Modal = ({setIsOpen, modalContent, contentClasses}) => {
  const modalRef = useRef(null); // Ref for modal container

  useEffect(() => {
    if (setIsOpen) {
      document.body.classList.add('modal-opened');
      document.documentElement.classList.add('modal-opened');

      // Move focus to the modal
      modalRef.current?.focus();
    }

    const closeModalOnESC = (event) => {
      if (event.key === 'Escape') {
        closeModal();
      }
    };

    const trapFocus = (event) => {
      if (event.key === 'Tab') {
        const focusableElements = modalRef.current.querySelectorAll(
          'a, button, textarea, input, select, [tabindex]:not([tabindex="-1"])'
        );
        const firstElement = focusableElements[0];
        const lastElement = focusableElements[focusableElements.length - 1];

        if (event.shiftKey && document.activeElement === firstElement) {
          event.preventDefault();
          lastElement.focus();
        } else if (!event.shiftKey && document.activeElement === lastElement) {
          event.preventDefault();
          firstElement.focus();
        }
      }
    };

    document.addEventListener('keyup', closeModalOnESC);
    modalRef.current?.addEventListener('keydown', trapFocus);

    return () => {
      document.removeEventListener('keyup', closeModalOnESC);
      modalRef.current?.removeEventListener('keydown', trapFocus);
    };
  }, [setIsOpen]);

  const closeModal = () => {
    document.documentElement.classList.remove('modal-opened');
    document.body.classList.remove('modal-opened');

    setIsOpen(false);
  };

  return (
    <div ref={modalRef}
         className="modal flex py-48 lg:p-48 fixed inset-0 bg-black items-center justify-center"
         role="dialog" aria-modal="true" tabIndex="-1">
      <Button buttonClasses="button js-modal-close button--clear modal__close-button" onClick={closeModal}
              aria-label="Close Modal">
        <CloseIcon/>
      </Button>

      <div className={`modal-content p-15 ${contentClasses || ''}`} id="modalContent">
        {modalContent}
      </div>
    </div>
  );
};

export default Modal;
